const transparent_button_whiteText = {
    backgroundColor: 'transparent',     // Arka plan rengi kırmızı
    color: 'white',              // Yazı rengi beyaz
    fontWeight: 'bold',          // Kalın yazı
    border: '1px solid white'    // border 1px solid tipinde white renginde
  };
  
  export default transparent_button_whiteText;
  